import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { EmailVerifiedPage } from "@/features/onboarding/pages/email-verified-page";

export const Route = createFileRoute("/onboarding/_guarded/email-verified")({
	head: () => pageTitle("Verify your email address"),
	component: EmailVerifiedPage,
});
